import { ActionType } from '@/types/actionType';
import { ROLES } from '../../constants/global';
import { IMPERSONATE_SUCCESS } from '../impersonate/actionTypes';
import {
	IMPERSONATE,
	IS_AUTHENTICATED,
	LOG_IN,
	LOG_OUT,
	PROFILE_IMAGE,
	REMOVE_AUTHENTICATION,
	SET_UNIT_SYSTEM,
	SET_USER_LANGUAGE_ID,
	UPDATE_REFRESH_TOKEN,
	USER_FORCE_PASSWORD,
} from './actionTypes';

const initState = {
	user: {
		name: '',
	},
	client: {
		id: 0,
	},
	company: {
		id: 0,
	},
	isAuthenticated: false,
	roles: [],
	isMaster: false,
	token: '',
	refreshToken: '',
	expiresIn: '',
};

const reducer = (state = initState, action) => {
	switch (action.type) {
		case USER_FORCE_PASSWORD:
			return {
				...state,
				user: {
					...state.user,
					...action.user,
				},
			};
		case PROFILE_IMAGE: {
			return {
				...state,
				user: {
					...state.user,
					image: true,
				},
			};
		}
		case IMPERSONATE:
		case IMPERSONATE_SUCCESS:
		case LOG_IN:
			return {
				...state,
				user: {
					...state.user,
					...action.user,
				},
				company: action.company,
				isMaster: action.userRoles?.includes(ROLES.MASTER) || false,
				roles: action.userRoles ?? [],
				client: action.client,
				token: action.token,
				refreshToken: action.refreshToken,
				expiresIn: action.expiresIn,
			};
		case IS_AUTHENTICATED:
			return {
				...state,
				isAuthenticated: true,
			};
		case REMOVE_AUTHENTICATION:
			return {
				...state,
				isAuthenticated: false,
			};
		case SET_UNIT_SYSTEM:
			return {
				...state,
				user: {
					...state.user,
					unitSystemConfig: action.unitSystemConfig,
				},
			};
		case SET_USER_LANGUAGE_ID:
			return {
				...state,
				user: {
					...state.user,
					languageId: action.languageId,
				},
			};
		case UPDATE_REFRESH_TOKEN:
			return {
				...state,
				token: action.token,
				refreshToken: action.refreshToken,
				expiresIn: action.expiresIn,
				roles: action.roles ?? [],
			};
		case ActionType.USER_UPDATE_PROFILE:
			return {
				...state,
				user: {
					...state.user,
					...action.user,
				},
			};
		case ActionType.TWO_FACTOR_AUTH_STATUS:
			return {
				...state,
				user: {
					...state.user,
					twoFaEnabledAt: action.payload.twoFaEnabledAt,
					default2FAMethod: action.payload.default2FAMethod,
				},
			};
		case ActionType.USER_UPDATE_REQUIRES_PHONE_VERIFICATION:
			return {
				...state,
				user: {
					...state.user,
					requiresPhoneVerification: action.payload.requiresPhoneVerification,
					remindPhoneVerificationAt: action.payload.remindPhoneVerificationAt,
					cellphone: action.payload.cellphone,
					twoFaEnabledAt: action.payload.twoFaEnabledAt,
					default2FAMethod: action.payload.default2FAMethod,
				},
			};
		case ActionType.SET_RETENTION_DISCOUNT_APPLIED_AT:
			return {
				...state,
				client: {
					...state.client,
					retentionDiscountAppliedAt: action.payload.retentionDiscountAppliedAt,
				},
			};
		case ActionType.SET_WHATS_INCLUDED_SEEN_AT:
			return {
				...state,
				client: {
					...state.client,
					whatsIncludedSeenAt: action.payload.whatsIncludedSeenAt,
				},
			};
		case LOG_OUT:
			return initState;
		default:
			return state;
	}
};

export default reducer;
